/** @format */
//TODO: Remove suppress and fix the error
/* eslint-disable react/no-string-refs */
import React from 'react';
import PropTypes from 'prop-types';
import { Auth } from '../modules/auth/Auth';
import { history } from '../core/history';
import LogginPage from '../views/Pages/LoginPage';
import withStyles from '@material-ui/core/styles/withStyles';
import AuthNavbar from 'components/Navbars/AuthNavbarExt.jsx';
import Footer from 'components/Footer/Footer.jsx';
import pagesStyle from 'assets/jss/material-dashboard-pro-react/layouts/authStyle';

import login from 'assets/img/login.jpeg';
import SnackBarMessage from '../helpers/SnackBarMessage';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { notificationConstants } from '../modules/notifications/notifications';
import oplAppStyle from '../assets/themes/OPL/jss/App/OplAppStyle';

class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            snackBarStatus: false,
            snackBarMessage: '',
            snackBarVariant: 'success',
        };
        if (Auth.isValidToken()) {
            history.push(process.env.REACT_APP_DEFAULT_PAGE);
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.status !== notificationConstants.CLEAR_NOTIFY) {
            if (nextProps.variant && nextProps.message) {
                this.displayNotify(true, i18n.t(nextProps.message), nextProps.variant, '');
            }
        }
        return true;
    }

    displayNotify = (status, message, variant, title) => {
        const { dispatch } = this.props;
        this.setState(
            (prevProps) => ({
                snackBarStatus: status,
                snackBarMessage: message,
                snackBarVariant: variant,
            }),
            () => {
                dispatch({ type: notificationConstants.CLEAR_NOTIFY });
            }
        );
    };

    closeSnackbarCallback = () => {
        this.setState({ snackBarStatus: false, snackBarMessage: '' });
    };

    componentDidMount() {
        document.body.style.overflow = 'unset';
    }

    getBgImage = () => {
        if (window.location.pathname.indexOf(process.env.REACT_APP_LOGIN_PAGE) !== -1) {
            return login;
        }
        return login;
    };

    render() {
        const { classes } = this.props;
        return (
            <div>
                <AuthNavbar />
                <div className={classes.loginWrapper} ref="wrapper">
                    <div className={classes.fullPage}>
                        <LogginPage />
                        <Footer white />
                    </div>
                </div>
                <SnackBarMessage
                    closeCallback={this.closeSnackbarCallback}
                    open={this.state.snackBarStatus}
                    text={this.state.snackBarMessage}
                    variant={this.state.snackBarVariant}
                />
            </div>
        );
    }
}

Pages.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { notify } = state;
    return {
        status: notify.type,
        error: notify.error,
        message: notify.message,
        variant: notify.variant,
    };
};

const enhance = compose(connect(mapStateToProps), withStyles(oplAppStyle));
const Enhance = enhance(Pages);
export default Enhance;
